// extracted by mini-css-extract-plugin
module.exports = {"TabsCard":"TabsCard___PhprM"};